export const LASTLY_APPLIED_FILTERS_KEY = 'lastly_applied_filters';
